import { render, staticRenderFns } from "./FeededList.vue?vue&type=template&id=f2b5a9c6"
import script from "./FeededList.vue?vue&type=script&lang=js"
export * from "./FeededList.vue?vue&type=script&lang=js"
import style0 from "./FeededList.vue?vue&type=style&index=0&id=f2b5a9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports